import React from 'react';

/**
 * The tinycms wordmark: "tinycms." in lower case with the full stop in the
 * accent (ink.css .ink-wordmark). Use it wherever the brand is shown as a
 * logo; product copy in sentences still says "tinycms". `suffix` names a
 * sub-product the way smagent-ops does ("tinycms. ops").
 */
export function TinycmsWordmark({
  suffix,
  className = '',
}: {
  suffix?: string;
  className?: string;
}) {
  return (
    <span className={`ink-wordmark ${className}`.trim()}>
      tinycms<span className="ink-wordmark-dot">.</span>
      {suffix ? <span className="ink-wordmark-suffix">{suffix}</span> : null}
    </span>
  );
}
